import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { OnboardingStep } from '../models';
import { Coverage3dOnboardingDeviceBehaviorService } from '../services';

@Pipe({ name: 'onboardingStepDescription', standalone: true })
export class OnboardingStepDescriptionPipe implements PipeTransform {
	private readonly transloco = inject(TranslocoService);
	private readonly deviceBehavior = inject(Coverage3dOnboardingDeviceBehaviorService);

	public transform(step: OnboardingStep, model: DeviceModel): string {
		// Prioritize the device-specific description if available
		const description = this.deviceBehavior.getStepDescription(model, step);
		if (description) {
			return description;
		}

		// Apply default descriptions based on the step if no device-specific description is available
		switch (step) {
			case OnboardingStep.SceneClickAndDrag:
				return this.transloco.translate(
					'scCoverage3dOnboarding.onboarding-steps.scene-click-and-drag.description'
				);
			case OnboardingStep.LobeAdd:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-steps.lobe-add.description');
			case OnboardingStep.LobeClickAndDrag:
				return this.transloco.translate(
					'scCoverage3dOnboarding.onboarding-steps.lobe-click-and-drag.description'
				);
			case OnboardingStep.LobeMultiSelect:
				return this.transloco.translate(
					'scCoverage3dOnboarding.onboarding-steps.lobe-multi-select.description'
				);
			case OnboardingStep.LobeSnap:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-steps.lobe-snap.description');
			default:
				return '';
		}
	}
}
